import Vue from 'vue'

import VueJsonPretty from 'vue-json-pretty'

Vue.component('vue-json-pretty', VueJsonPretty)
